module.exports = __webpack_public_path__ + "assets/img/052.542783a3.png";